/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneDialog as ResolvedStandaloneDialog } from 'base/components/standalone/Dialog';

export const Dialog: typeof ResolvedStandaloneDialog = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneDialog {...props} />
    );
});

export type DialogProps = PropsFromComponent<typeof Dialog>;

/** @deprecated Use slot architecture instead */
export const DialogWith = (extras: DynamicStandaloneExtras): typeof Dialog => {
    return function Dialog(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Dialog');
        return <ResolvedStandaloneDialog {...mergeProps({ options: { theme } }, props)} />;
    }
}